import { ComponentDataSourceService } from '../../component-data-source.service';
import { Observable } from 'rxjs';
import { DataSourceFunction } from '../../component-data-source.service';
import { Event } from '../../../../interfaces/old/event.interfaces';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

export const event_search = (service: ComponentDataSourceService): DataSourceFunction => ({
  name: 'Event Search',
  description: 'Search for events',
  execute: (params?: LoadDataParams): Observable<Event[]> => {
    const queryParams = params?.queryParams || {};
    return service.http.get<Event[]>(`${environment.apiUrl}/events/search`, { params: queryParams });
  }
}); 